var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00813 1.04989C3.25322 1.07281 1.02698 3.33641 1.04991 6.09132C1.07283 8.84622 3.33643 11.0725 6.09134 11.0495C8.84624 11.0266 11.0725 8.76301 11.0496 6.00811C11.0266 3.2532 8.76303 1.02696 6.00813 1.04989ZM5.6581 4.0529C5.6564 3.84791 5.82498 3.6765 6.02997 3.6748C6.23496 3.67309 6.40637 3.84167 6.40808 4.04666L6.42888 6.54658C6.43059 6.75157 6.26201 6.92298 6.05701 6.92468C5.85202 6.92639 5.68061 6.75781 5.67891 6.55282L5.6581 4.0529ZM6.52794 8.23581C6.50348 8.30102 6.4689 8.3513 6.42432 8.40168C6.37469 8.44709 6.31999 8.48255 6.2602 8.50805C6.20041 8.53355 6.13553 8.54909 6.07054 8.54963C6.00554 8.55017 5.94042 8.53571 5.88021 8.51121C5.82 8.48671 5.76471 8.45217 5.71434 8.40759C5.66893 8.35796 5.63351 8.30825 5.60797 8.24346C5.58247 8.18367 5.56693 8.1188 5.56639 8.0538C5.56585 7.98881 5.58031 7.92368 5.60481 7.86348C5.62931 7.80327 5.66385 7.74798 5.70843 7.69761C5.75806 7.6522 5.81276 7.61674 5.87255 7.59124C5.99213 7.54024 6.13213 7.53908 6.25254 7.58808C6.31275 7.61258 6.36804 7.64712 6.41841 7.6917C6.46382 7.74133 6.49928 7.79603 6.52478 7.85582C6.55028 7.91561 6.56582 7.98049 6.56636 8.04548C6.5669 8.11048 6.55244 8.1756 6.52794 8.23581Z",
    fill: "#9186A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleFilled);
export default __webpack_public_path__ + "static/media/info-circle-filled.d70fc725a61656bda175576d346acaba.svg";
export { ForwardRef as ReactComponent };